export default __webpack_public_path__ + "static/media/delete.aec5c5e2.svg";